import "react";
import o from "./createSvgIcon3.mjs";
import { jsx as r } from "react/jsx-runtime";
const n = o(/* @__PURE__ */ r("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
export {
  n as default
};
//# sourceMappingURL=ArrowDropDown.mjs.map
